import { observable } from "mobx";
import { Type } from "class-transformer";
import RefundApprovalResponse from "./refundApprovalResponse";
import RefundTransferPaymentResponse from "./refundTransferPaymentResponse";
import type { IRefund } from "./types";
import RefundChargeDetailResponse from "./refundChargeDetailResponse";
import RefundOriginalTransferPaymentDetailResponse from "./refundOriginalTransferPaymentDetailResponse";
import RefundFeeResponse from "./refundFeeResponse";
import RefundPermittedActionsResponse from "./refundPermittedActionsResponse";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class TransferRefundDetailResponse {
  id!: string;

  @observable
  refundPaymentTemplateId!: string;

  @observable
  refundAmount!: number;

  @observable
  @Type(() => RefundChargeDetailResponse)
  charge?: RefundChargeDetailResponse;

  @observable
  @Type(() => RefundFeeResponse)
  fees!: RefundFeeResponse[];

  @observable
  @Type(() => RefundPermittedActionsResponse)
  permittedActions!: RefundPermittedActionsResponse;

  @observable
  @Type(() => RefundApprovalResponse)
  approvals!: RefundApprovalResponse[];

  @observable
  officialRecordId?: string;

  @observable
  @Type(() => RefundOriginalTransferPaymentDetailResponse)
  originalPayment?: RefundOriginalTransferPaymentDetailResponse;

  @observable
  @Type(() => RefundTransferPaymentResponse)
  refundPayment!: RefundTransferPaymentResponse;

  @observable
  @Type(() => DomesticBankAccountResponse)
  refundSenderBankAccount!: DomesticBankAccountResponse;
}

export default class TransferRefundDetail extends TransferRefundDetailResponse implements IRefund {
  @observable
  isSelectable: boolean;
}
